/* Welcome popup: exit intent, never over scrolling or an open drawer. Floating button after the first close. All values come from the theme editor. */
(() => {
  const p = document.getElementById('sdjPromo'), tab = document.getElementById('sdjPromoTab');
  if (!p) return;
  const d = p.dataset, design = !!(window.Shopify && Shopify.designMode);
  const noPopup = document.body.dataset.noPopup !== undefined;
  const get = (k, f) => { try { const v = localStorage.getItem(k); return v === null ? f : JSON.parse(v); } catch (e) { return f; } };
  const set = (k, v) => { if (design) return; try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  const num = (v, f) => { const n = Number(v); return isNaN(n) ? f : n; };
  const code = d.code, started = Date.now();
  const repeatMs = num(d.repeatHours, 24) * 36e5, minMs = num(d.minSeconds, 5) * 1e3, quietMs = num(d.scrollQuiet, 1.5) * 1e3;
  const expandMs = num(d.tabExpand, 4) * 1e3, tabRepeatMs = num(d.tabRepeat, 30) * 1e3;
  let lastScroll = 0, tabTimer = 0, tabLoop = 0;

  const collapse = () => { if (tab) tab.classList.remove('is-expanded'); };
  const playTab = () => {
    if (!tab) return;
    tab.classList.add('is-expanded');
    clearTimeout(tabTimer);
    tabTimer = setTimeout(collapse, expandMs);
  };
  const showTab = () => {
    if (!tab || noPopup || get('sdj-promo-claimed', false)) return;
    if (!design && !get('sdj-promo-closed', false)) return;
    tab.classList.add('is-visible');
    setTimeout(playTab, 350);
    clearInterval(tabLoop);
    if (tabRepeatMs > 0) tabLoop = setInterval(() => { if (!document.hidden && tab.classList.contains('is-visible')) playTab(); }, tabRepeatMs + expandMs);
  };
  const hideTab = () => { if (!tab) return; tab.classList.remove('is-visible', 'is-expanded'); clearInterval(tabLoop); clearTimeout(tabTimer); };

  const open = () => {
    if (p.classList.contains('is-open')) return;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    hideTab();
    set('sdj-promo-seen', Date.now());
  };
  const close = () => {
    if (!p.classList.contains('is-open')) return;
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) document.body.classList.remove('is-locked');
    set('sdj-promo-closed', true);
    showTab();
  };

  const blocked = () => {
    if (d.blockDrawers === 'true' && document.querySelector('.drawer.is-open')) return true;
    if (d.blockScroll === 'true' && Date.now() - lastScroll < quietMs) return true;
    return false;
  };
  const tryOpen = () => {
    if (noPopup || design || get('sdj-promo-claimed', false)) return;
    if (Date.now() - started < minMs) return;
    if (Date.now() - get('sdj-promo-seen', 0) < repeatMs) return;
    if (blocked()) return;
    open();
  };

  p.querySelectorAll('[data-promo-close]').forEach(b => b.addEventListener('click', close));
  if (tab) tab.addEventListener('click', open);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  const markScroll = () => { lastScroll = Date.now(); };
  window.addEventListener('scroll', markScroll, { passive: true });
  window.addEventListener('wheel', markScroll, { passive: true });
  window.addEventListener('touchmove', markScroll, { passive: true });

  if (p.classList.contains('is-done')) {
    set('sdj-promo-claimed', true);
    open();
    if (code) { set('sdj-promo', code); if (window.SDJ && SDJ.applyDiscount) SDJ.applyDiscount(code).catch(() => {}); }
  } else if (d.hasErrors === 'true') {
    open();
  } else {
    showTab();
    const exitPx = num(d.exitPx, 12);
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < exitPx) tryOpen(); });
    } else {
      const mode = d.mobileTrigger || 'return';
      if (mode === 'return' || mode === 'both') {
        let hiddenAt = 0;
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { hiddenAt = Date.now(); return; }
          if (hiddenAt && Date.now() - hiddenAt > 2000) { lastScroll = 0; tryOpen(); }
        });
      }
      if (mode === 'idle' || mode === 'both') {
        const idleMs = num(d.idleSeconds, 30) * 1e3;
        let t = 0;
        const arm = () => { clearTimeout(t); t = setTimeout(() => { tryOpen(); arm(); }, idleMs); };
        ['scroll', 'touchstart', 'touchmove', 'keydown'].forEach(n => window.addEventListener(n, arm, { passive: true }));
        arm();
      }
    }
  }

  document.addEventListener('shopify:section:select', e => { if (e.target.contains(p)) open(); });
  document.addEventListener('shopify:section:deselect', e => { if (e.target.contains(p)) close(); });

  if (document.querySelector('[data-newsletter-success]') && code) {
    set('sdj-promo-claimed', true);
    set('sdj-promo', code);
    hideTab();
    if (window.SDJ && SDJ.applyDiscount) SDJ.applyDiscount(code).catch(() => {});
  }
})();
